import React from "react";
import { useTranslation } from "react-i18next";

const DownloadApp: React.FC = () => {
  const { t } = useTranslation("webReceipt");

  return (
    <div className="w-full flex flex-col items-stretch">
      <div className="rounded-lg p-4 flex items-center gap-3 mx-5 mt-1 mb-2 max-w-full bg-brand-blue-light">
        <img
          // src="https://play-lh.googleusercontent.com/Br8kciXir0Rmt7E9zyPTGX1QlRZuBvoEsDW2H-rUfwiCBH1R9wSCLEppVTaI-GapYw=w480-h960-rw"
          src="/App_store_1024_1x.svg"
          alt="DASH App"
          className="w-12 h-12 rounded-[10px] flex-shrink-0 self-center"
        />
        <div className="flex-1 flex flex-col justify-center">
          <span className="text-base font-semibold text-mineshaft-900 leading-tight">
            {t("tripScheduledBannerDescription")}
          </span>
        </div>
        <a
          href={
            process.env.REACT_APP_DASH_TAXI_DOWNLOAD_URL ||
            "https://l.d-ash.com/p0cu2"
          }
          className="text-base font-semibold text-primary-600 hover:underline whitespace-nowrap"
          target="_blank"
          rel="noopener noreferrer"
        >
          {t("tripScheduledBannerCta")}
        </a>
      </div>
    </div>
  );
};

export default DownloadApp;
